import React from 'react'
import AmountOffPricingInputs from './AmountOffPricingInputs'
import PurchaseConditions from './PurchaseConditions'
import MaxUsesPerOrder from '../../../MaxUsesPerOrder'
import { useLocale } from 'src/lib/hooks/useLocal'

const DiscountApplicationRulesAmountOff = () => {
  const { t } = useLocale()
  return (
    <div className='flex flex-col gap-3 w-full'>
      <h3 className='text-text-sm-semibold text-zinc-800'>{t('discounts_v2.set_discount')}</h3>

      <AmountOffPricingInputs />

      <PurchaseConditions />

      <MaxUsesPerOrder />
    </div>
  )
}

export default DiscountApplicationRulesAmountOff
